import { render, staticRenderFns } from "./ElectronicScreen.vue?vue&type=template&id=376b04cc&scoped=true"
import script from "./ElectronicScreen.vue?vue&type=script&lang=ts"
export * from "./ElectronicScreen.vue?vue&type=script&lang=ts"
import style0 from "./ElectronicScreen.vue?vue&type=style&index=0&id=376b04cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376b04cc",
  null
  
)

export default component.exports